import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import { api } from 'src/service';

const WasherKitDeductions = ({ washerId, refreshKey }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!washerId) return;
    let active = true;
    setLoading(true);
    api
      .get(`/paymentwasher/${washerId}`)
      .then((res) => {
        if (!active) return;
        const all = Array.isArray(res?.data?.data) ? res.data.data : [];
        setRows(all.filter((p) => p.type === 'Washer Kit Deduction'));
      })
      .catch((err) => console.error('Error loading kit deductions:', err))
      .finally(() => active && setLoading(false));
    // eslint-disable-next-line consistent-return
    return () => { active = false; };
  }, [washerId, refreshKey]);

  const total = rows.reduce(
    (acc, r) => acc + (parseFloat(r.payment_amount) || 0),
    0
  );

  return (
    <Card>
      <CardHeader title="Washer Kit Deductions" />
      <CardContent>
        <Box sx={{ position: 'relative', minHeight: loading ? 80 : 0 }}>
          {loading && (
            <CircularProgress
              size={24}
              style={{ position: 'absolute', top: 16, left: '45%' }}
            />
          )}
          {!loading && (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell align="right">Value</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((r) => (
                  <TableRow key={r.transaction_id}>
                    <TableCell>{r.date}</TableCell>
                    <TableCell align="right">
                      € {(parseFloat(r.payment_amount) || 0).toFixed(2)}
                    </TableCell>
                  </TableRow>
                ))}
                {rows.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={2}>
                      <Typography variant="body2" color="textSecondary">
                        No washer kit deductions.
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
                <TableRow>
                  <TableCell><strong>Total</strong></TableCell>
                  <TableCell align="right">
                    <strong>€ {total.toFixed(2)}</strong>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

WasherKitDeductions.propTypes = {
  washerId: PropTypes.string,
  refreshKey: PropTypes.number,
};

export default WasherKitDeductions;
